import React from "react";
import { Switch, Redirect } from "react-router-dom";
import WithdrawalContainer from "../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestContainer";
import { ManageDistributionProvider } from "../contexts";
import {
  WithdrawalRequest,
  TransferRequest,
  TransferSummary,
  RebalanceRequest,
  RebalanceSummary,
  WithdrawalSummary,
  LoanRequest,
  LoanSummary,
  WithdrawalAllocationLayout,
} from "../layouts";
// import WithdrawalRequest from "../layouts/Distribution/WithdrawalRequest/WithdrawalRequest";

import { ROUTES, ApplicationRoute, MANAGE_TRANSFER_ROUTES } from "../utils";
import { MANAGE_DISTRIBUTION_ROUTES } from "../utils/constants/distribution";

const menu = "distribution";
const flow = "edit";
export const ManageDistributionRoutes = () => {
  return (
    <Switch>
      <ApplicationRoute
        exact
        menu={menu}
        //   flow={flow}
        path={[
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:flow(add|edit|save)/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:flow(add|edit|save)/:censusId/:withdrawalRequestId?/:fromPage`,
          // `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:flow(add|edit|save)/:censusId/:withdrawalRequestId?/:fromDraftPage`,
        ]}
        component={WithdrawalRequest}
      />
      <ApplicationRoute
        exact
        menu={menu}
        //   flow={flow}
        path={[
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_ALLOCATION}/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_ALLOCATION}/:flow(add|edit|save)/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_ALLOCATION}/:flow(add|edit|save)/:censusId/:withdrawalRequestId?/:fromPage`,
          // `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_ALLOCATION}/:flow(add|edit|save)/:censusId/:withdrawalRequestId?/:fromDraftPage`,
        ]}
        component={WithdrawalAllocationLayout}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_TRANSFER_ROUTES.TRANSFER_REQUEST}/:censusId?`,
          `${MANAGE_TRANSFER_ROUTES.TRANSFER_REQUEST}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={TransferRequest}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_TRANSFER_ROUTES.TRANSFER_SUMMARY}/:censusId?`,
          `${MANAGE_TRANSFER_ROUTES.TRANSFER_SUMMARY}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={TransferSummary}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_TRANSFER_ROUTES.REBALANCE_REQUEST}/:censusId?`,
          `${MANAGE_TRANSFER_ROUTES.REBALANCE_REQUEST}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={RebalanceRequest}
      />

      <ApplicationRoute
        exact
        menu={menu}
        path={[
          `${MANAGE_TRANSFER_ROUTES.REBALANCE_SUMMARY}/:censusId?`,
          `${MANAGE_TRANSFER_ROUTES.REBALANCE_SUMMARY}/:flow(add|edit|save)/:censusId?`,
        ]}
        component={RebalanceSummary}
      />

      <ApplicationRoute
        exact
        menu={menu}
        //   flow={flow}
        path={[
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:flow(add|edit|save)/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:flow(add|edit|save)/:censusId?/:withdrawalRequestId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_REQUEST}/:flow(add|edit|save)/:censusId?/:withdrawalRequestId?/:fromPage?`,
        ]}
        component={WithdrawalRequest}
      />
      <ApplicationRoute
        exact
        menu={menu}
        //   flow={flow}
        path={[
          `${MANAGE_DISTRIBUTION_ROUTES.LOAN_REQUEST}/:flow(add|edit|save)/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.LOAN_REQUEST}/:flow(add|edit|save)/:censusId?/:loanRequestId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.LOAN_REQUEST}/:flow(add|edit|save)/:censusId?/:loanRequestId?/:fromPage`,
        ]}
        component={LoanRequest}
      />

      <ApplicationRoute
        exact
        menu={menu}
        //   flow={flow}
        path={[
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}/:flow(add|edit|save)/:censusId?/:withdrawalRequestId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}/:flow(add|edit|save)/:censusId?/:withdrawalRequestId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.WITHDRAWAL_SUMMARY}/:flow(add|edit|save)/:censusId?/:withdrawalRequestId?/:fromPage`,
        ]}
        component={WithdrawalSummary}
      />
      <ApplicationRoute
        exact
        menu={menu}
        //   flow={flow}
        path={[
          `${MANAGE_DISTRIBUTION_ROUTES.LOAN_SUMMARY}/:censusId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.LOAN_SUMMARY}/:flow(add|edit|save)/:censusId?/:loanRequestId?`,
          `${MANAGE_DISTRIBUTION_ROUTES.LOAN_SUMMARY}/:flow(add|edit|save)/:censusId?/:loanRequestId?/:fromPage`,
        ]}
        component={LoanSummary}
      />

      {/* <Redirect
        exact
        menu={menu}
        from={ROUTES.DISTRIBUTION}
        to={ROUTES.WITHDRAWAL_REQUEST}
      /> */}
      {/* <Redirect to={ROUTES.HOME} /> */}
    </Switch>
  );
};
